module.exports = __webpack_public_path__ + "static/media/membership.565ec451.png";